export const P2_BASE_CSS_VARS = {
  "theme-website-p2-color-text": "var(--theme-website-color-text-secondary)",
  "theme-website-p2-font-family": "InterVariable",
  "theme-website-p2-font-size": "1rem",
  "theme-website-p2-font-weight": "400",
  "theme-website-p2-line-height": "1.6",
  "theme-website-p2-letter-spacing": "0",
};
